// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  font-family: ABBVoice;
  margin: 0;
  background-size: contain;
  background-repeat: no-repeat;
}

.case-creation-form {
  display: flex;
  height: 100%;
  width: 100%;
  padding: 0px 20px;
  /* The tooltip */
  /* The pointer of the tooltip */
  /* Prevents the tooltip from being hidden */
  /* CSS animation */
}
.case-creation-form #scp_salesforce {
  width: 100%;
}
.case-creation-form .header {
  text-align: left;
  color: rgb(87, 163, 0);
  font-size: large;
  margin-left: 5%;
}
.case-creation-form .status-display {
  margin-left: -10%;
  margin-top: 10%;
}
.case-creation-form .test-msg {
  font-size: 12px;
  display: block;
  margin: 12px 12px;
  font-family: ABBVoice-Regular;
}
.case-creation-form .topnav {
  overflow: hidden;
  border: 0px;
  position: relative;
  min-height: 60px;
  background-color: #fff;
  border-bottom: 0px solid transparent;
  border-color: rgba(255, 255, 255, 0.25);
  box-shadow: 0px 0px 0px #bdbdbd inset;
  box-shadow: 15px 0px 15px -10px rgba(0, 0, 0, 0.75);
  margin-bottom: 3px;
  -webkit-transition: 250ms opacity ease-in-out;
  font-family: "abbvoiceregular", "Verdana", "Arial", sans-serif !important;
}
.case-creation-form .topnav a {
  float: right;
  color: #000000;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  font-size: 17px;
  margin-right: 1%;
}
.case-creation-form .topnav a:hover {
  color: #ff000f;
}
.case-creation-form .hr {
  background-color: #ff000f;
  height: 7px;
  width: 43px;
  display: block;
  margin-top: 25px;
  margin-bottom: 13px;
  border: none;
}
.case-creation-form .logo {
  float: left;
  display: block;
  line-height: 2rem !important;
  margin-top: 1%;
  margin-left: 5%;
  padding-top: -3px;
  margin-bottom: 10px;
  max-height: 35px;
  font-size: 25px;
}
.case-creation-form .divider {
  border-left: 1px solid #9f9f9f;
  height: 90%;
  margin-top: 10px;
  margin-left: 0.5%;
}
.case-creation-form .row_c {
  display: block;
  min-width: 500px;
}
.case-creation-form .row {
  min-width: 500px;
  display: inline-flex;
  margin-bottom: 2%;
}
.case-creation-form .contents {
  min-width: 400px;
  float: left;
  margin-right: 6.5%;
}
.case-creation-form .contents2 {
  min-width: 400px;
  float: left;
  margin-left: 40%;
}
.case-creation-form .contents3 {
  min-width: 400px;
  float: left;
  margin-right: 63%;
}
.case-creation-form .contents-disable {
  min-width: 400px;
  float: left;
  margin-right: 6.5%;
  pointer-events: none;
}
.case-creation-form .contents-button1 {
  min-width: 400px;
  float: center;
  margin-left: 35%;
}
.case-creation-form .back {
  background-color: black;
  min-width: 30px;
  float: left;
  margin-left: 6%;
  margin-top: 0.5%;
}
.case-creation-form .home {
  background-color: black;
  min-width: 30px;
  float: left;
  margin-left: 47%;
  margin-top: 3%;
}
.case-creation-form .label {
  font-family: ABBVoice-bold;
  font-size: 12px;
  text-align: left;
  margin-bottom: 0.1%;
}
.case-creation-form .input-readonly {
  font-family: ABBVoice;
  font-size: small;
  width: 25%;
  height: 27px;
  color: #bdbdbd;
  border: 1px solid #bdbdbd;
  transition: 0.5s;
  outline: none;
  pointer-events: none;
  border-radius: 5px;
}
.case-creation-form .dropdown {
  font-family: ABBVoice;
  font-size: small;
  width: 280px;
  transition: 0.5s;
  outline: none;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
}
.case-creation-form .dropdown:focus {
  border: 1px solid rgb(51, 102, 255);
}
.case-creation-form .attach-file {
  font-family: ABBVoice;
  font-size: medium;
  color: gray;
  width: 395px;
  height: 35px;
  border: none;
  transition: 0.5s;
  outline: none;
}
.case-creation-form select {
  font-family: ABBVoice;
  font-size: medium;
  color: gray;
  width: 400px;
  height: 40px;
}
.case-creation-form textarea {
  font-family: ABBVoice;
  font-size: medium;
  color: var(--text-primary-color);
  min-width: 200px;
  min-height: 30px;
  align-items: left;
  margin-right: 10%;
  background-color: var(--input-field-color);
}
.case-creation-form .subheading {
  font-family: ABBVoice;
  font-family: ABBVoice-bold;
  font-size: 16px;
  margin-bottom: 2%;
}
.case-creation-form .subheading2 {
  font-family: ABBVoice;
  font-family: ABBVoice-bold;
  font-size: large;
  /* font-style: italic; */
  text-align: left;
  margin-bottom: 1%;
}
.case-creation-form .button-section {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 14px;
  flex-direction: row;
}
.case-creation-form .button-cancel,
.case-creation-form .button-submit {
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: background-color 0.3s ease;
  border-radius: 20px;
}
.case-creation-form .button-attachfile {
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid transparent;
  transition: background-color 0.3s ease;
  border-radius: 20px;
}
.case-creation-form .button-submit {
  background: #36f;
  color: white;
  display: inline-flex;
  height: 31px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  text-align: center;
  font-family: ABBvoice;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
.case-creation-form .file-upload-container {
  display: flex;
  align-items: center; /* Align items vertically in the center */
  gap: 10px; /* Space between the button and the message */
  margin: 16px 0;
}
.case-creation-form .file-format-message {
  font-size: 12px;
  color: var(--format-message-case-creation);
  margin-left: 10px;
}
.case-creation-form .button-attachfile {
  background: #36f;
  color: white;
  display: inline-flex;
  height: 31px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  text-align: center;
  font-family: ABBvoice;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
.case-creation-form .button-cancel {
  background: #fff;
  color: #000;
  display: inline-flex;
  height: 31px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  text-align: center;
  font-family: ABBvoice;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  border: 1px solid #0051ff;
}
.case-creation-form .button-cancel:hover {
  background-color: rgba(0, 0, 0, 0.12);
}
.case-creation-form .button-attachfile:hover {
  background-color: #0056b3;
}
.case-creation-form .privacy-policy-link {
  text-decoration: none;
  color: var(--privacy-policy-link-color);
}
.case-creation-form .contents-button2 {
  min-width: 400px;
  float: center;
  margin-right: 10%;
  text-align: center;
  text-decoration: none;
  font-size: 14px;
  margin-left: 75%;
}
.case-creation-form .loader {
  margin-left: 80%;
  margin-right: 10%;
  min-width: 500px;
  /* align-items: center; */
  display: none;
}
.case-creation-form .tick {
  align-items: left;
  margin-top: 6px;
  margin-right: 14px;
  max-width: 20px;
  float: left;
}
.case-creation-form .required label {
  font-weight: bold;
}
.case-creation-form .required label::before {
  color: #e32;
  content: " *";
  display: inline;
}
.case-creation-form .header img {
  float: left;
  width: 50px;
  height: 50px;
}
.case-creation-form .asterisk {
  color: rgb(217, 83, 79);
  font-size: 18px;
  font-family: ABBVoice-bold;
}
.case-creation-form .form-container {
  background-color: var(--container-background-color);
  border-radius: 10px;
  padding: 2px;
}
.case-creation-form .form-container .contact-us-heading {
  font-size: 14px;
  font-weight: 500;
  background-color: var(--title-container-background);
  padding: 4px 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.case-creation-form .form-container .form-wrapper {
  background-color: var(--title-container-background);
  margin: 12px;
  padding: 16px;
  border-radius: 4px;
}
.case-creation-form .form-container .form-wrapper .field-container {
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.case-creation-form .form-container .form-wrapper .field-container .input-wrapper {
  width: 280px;
}
.case-creation-form .form-container .form-wrapper .field-container .label {
  width: 100px;
}
.case-creation-form .arrow {
  color: black;
  font-size: 18px;
  text-decoration: none;
  margin-bottom: 1%;
  text-align: left;
}
.case-creation-form .arrow a {
  text-decoration: none;
  color: inherit;
}
.case-creation-form .file-input {
  display: none;
}
.case-creation-form .upload-button {
  background-color: rgb(189, 189, 189);
  padding: 5px 20px;
  border-radius: 85px;
  border: none;
  color: white;
  cursor: pointer;
  margin-right: 2%;
  font-size: 12px;
}
.case-creation-form .error {
  color: #ad0707;
}
.case-creation-form .file_list {
  display: none;
}
.case-creation-form .help-tip:before {
  content: "🛈";
  font-family: sans-serif;
  font-weight: normal;
  color: #444;
  margin-left: 98.3%;
  font-size: 20px;
}
.case-creation-form .help-tip:hover p {
  display: block;
  transform-origin: 100% 0%;
  animation: fadeIn 0.3s ease;
}
.case-creation-form .help-tip p {
  display: none;
  font-family: sans-serif;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  background-color: #ffffff;
  padding: 15px 16px;
  width: 310px;
  height: 2px;
  position: absolute;
  left: 86.5%;
  top: 24%;
  transform: translate(-50%, 5%);
  border-radius: 3px;
  /* 	border: 1px solid #E0E0E0; */
  box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.1);
  color: #37393d;
  font-size: 12px;
  line-height: 18px;
  z-index: 99;
}
.case-creation-form .help-tip p:before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-bottom-color: #ffffff;
  top: 1px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.case-creation-form .help-tip p:after {
  width: 10px;
  height: 40px;
  content: "";
  position: absolute;
  top: -40px;
  left: 0;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 100%;
  }
}
.case-creation-form .form-block {
  background-color: var(--title-container-background);
  justify-content: center;
}
.case-creation-form .form-block .input-wrapper {
  width: 280px;
}
.case-creation-form .form-block-select .input-wrapper {
  width: 280px;
}
.case-creation-form .error-message {
  color: "red";
}
.case-creation-form .file-message {
  white-space: nowrap;
  /*margin-left: 20%;*/
}
.case-creation-form .selected-file .label {
  font-weight: 600;
  margin-right: 33px;
}
.case-creation-form .remove-file-button {
  font-size: 10px;
  border: none;
  background-color: #f5f5f5;
  color: #3366ff;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: bold;
}
.case-creation-form .remove-file-button:hover {
  background-color: #f5f5f5;
  color: #ff000f;
  font-size: 15px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/casecreationform.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,qBAAA;EACA,SAAA;EACA,wBAAA;EACA,4BAAA;AAEF;;AAAA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EAmbA,gBAAA;EAuBA,+BAAA;EAaA,2CAAA;EAUA,kBAAA;AA1dF;AANE;EACE,WAAA;AAQJ;AANE;EACE,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAQJ;AANE;EACE,iBAAA;EACA,eAAA;AAQJ;AANE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,6BAAA;AAQJ;AANE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;EACA,uCAAA;EACA,qCAAA;EACA,mDAAA;EACA,kBAAA;EACA,6CAAA;EACA,yEAAA;AAQJ;AALE;EACE,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAOJ;AAJE;EACE,cAAA;AAMJ;AAJE;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAMJ;AAJE;EACE,WAAA;EACA,cAAA;EACA,4BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAMJ;AAJE;EACE,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAMJ;AAHE;EACE,cAAA;EACA,gBAAA;AAKJ;AAFE;EACE,gBAAA;EACA,oBAAA;EACA,iBAAA;AAIJ;AADE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAGJ;AAAE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;AAEJ;AACE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AACJ;AACE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AAEE;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;AAAJ;AAGE;EACE,uBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AADJ;AAGE;EACE,uBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAGE;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,qBAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EAEA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;AAFJ;AAIE;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EAEA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAFJ;AAIE;EACE,mCAAA;AAFJ;AAIE;EACE,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EAEA,gBAAA;EACA,aAAA;AAFJ;AAIE;EACE,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAFJ;AAKE;EACE,qBAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0CAAA;AAHJ;AAME;EACE,qBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;AAJJ;AAOE;EACE,qBAAA;EACA,0BAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;AALJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AALJ;AAOE;;EAEE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,sCAAA;EACA,mBAAA;AALJ;AAOE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,sCAAA;EACA,mBAAA;AALJ;AAQE;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;AAQE;EACE,aAAA;EACA,mBAAA,EAAA,yCAAA;EACA,SAAA,EAAA,6CAAA;EACA,cAAA;AANJ;AAQE;EACE,eAAA;EACA,0CAAA;EACA,iBAAA;AANJ;AASE;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;AAUE;EACE,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AARJ;AAWE;EACE,qCAAA;AATJ;AAYE;EACE,yBAAA;AAVJ;AAYE;EACE,qBAAA;EACA,uCAAA;AAVJ;AAaE;EACE,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAXJ;AAaE;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;AAXJ;AAcE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAZJ;AAeE;EACE,iBAAA;AAbJ;AAeE;EACE,WAAA;EACA,aAAA;EACA,eAAA;AAbJ;AAeE;EACE,WAAA;EACA,WAAA;EACA,YAAA;AAbJ;AAeE;EACE,uBAAA;EACA,eAAA;EACA,0BAAA;AAbJ;AAgBE;EACE,mDAAA;EACA,mBAAA;EACA,YAAA;AAdJ;AAeI;EACE,eAAA;EACA,gBAAA;EACA,mDAAA;EACA,iBAAA;EACA,4BAAA;EACA,2BAAA;AAbN;AAeI;EACE,mDAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAbN;AAeM;EACE,aAAA;EACA,qBAAA;EACA,SAAA;AAbR;AAeQ;EACE,YAAA;AAbV;AAeQ;EACE,YAAA;AAbV;AAkBE;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAhBJ;AAmBE;EACE,qBAAA;EACA,cAAA;AAjBJ;AAoBE;EACE,aAAA;AAlBJ;AAqBE;EACE,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAnBJ;AAsBE;EACE,cAAA;AApBJ;AAuBE;EACE,aAAA;AArBJ;AAwBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAtBJ;AAyBE;EACE,cAAA;EACA,yBAAA;EAEA,2BAAA;AAvBJ;AA2BE;EACE,aAAA;EACA,uBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,2CAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AAzBJ;AA4BE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,4BAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AA1BJ;AA8BE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;AA5BJ;AAyCE;EACE;IACE,UAAA;EA/BJ;EAiCE;IACE,aAAA;EA/BJ;AACF;AAkCE;EACE,mDAAA;EACA,uBAAA;AAhCJ;AAkCI;EACE,YAAA;AAhCN;AAoCI;EACE,YAAA;AAlCN;AAqCE;EACE,YAAA;AAnCJ;AAqCE;EACE,mBAAA;EACA,oBAAA;AAnCJ;AAuCI;EACE,gBAAA;EACA,kBAAA;AArCN;AAwCE;EACE,eAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAtCJ;AAyCE;EACE,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAvCJ","sourcesContent":["body {\r\n  font-family: ABBVoice;\r\n  margin: 0;\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n}\r\n.case-creation-form {\r\n  display: flex;\r\n  height: 100%;\r\n  width: 100%;\r\n  padding: 0px 20px;\r\n  #scp_salesforce {\r\n    width: 100%;\r\n  }\r\n  .header {\r\n    text-align: left;\r\n    color: rgb(87, 163, 0);\r\n    font-size: large;\r\n    margin-left: 5%;\r\n  }\r\n  .status-display {\r\n    margin-left: -10%;\r\n    margin-top: 10%;\r\n  }\r\n  .test-msg {\r\n    font-size: 12px;\r\n    display: block;\r\n    margin: 12px 12px;\r\n    font-family: ABBVoice-Regular;\r\n  }\r\n  .topnav {\r\n    overflow: hidden;\r\n    border: 0px;\r\n    position: relative;\r\n    min-height: 60px;\r\n    background-color: #fff;\r\n    border-bottom: 0px solid transparent;\r\n    border-color: rgba(255, 255, 255, 0.25);\r\n    box-shadow: 0px 0px 0px #bdbdbd inset;\r\n    box-shadow: 15px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    margin-bottom: 3px;\r\n    -webkit-transition: 250ms opacity ease-in-out;\r\n    font-family: \"abbvoiceregular\", \"Verdana\", \"Arial\", sans-serif !important;\r\n  }\r\n\r\n  .topnav a {\r\n    float: right;\r\n    color: #000000;\r\n    text-align: center;\r\n    padding: 14px 16px;\r\n    text-decoration: none;\r\n    font-size: 17px;\r\n    margin-right: 1%;\r\n  }\r\n\r\n  .topnav a:hover {\r\n    color: #ff000f;\r\n  }\r\n  .hr {\r\n    background-color: #ff000f;\r\n    height: 7px;\r\n    width: 43px;\r\n    display: block;\r\n    margin-top: 25px;\r\n    margin-bottom: 13px;\r\n    border: none;\r\n  }\r\n  .logo {\r\n    float: left;\r\n    display: block;\r\n    line-height: 2rem !important;\r\n    margin-top: 1%;\r\n    margin-left: 5%;\r\n    padding-top: -3px;\r\n    margin-bottom: 10px;\r\n    max-height: 35px;\r\n    font-size: 25px;\r\n  }\r\n  .divider {\r\n    border-left: 1px solid #9f9f9f;\r\n    height: 90%;\r\n    margin-top: 10px;\r\n    margin-left: 0.5%;\r\n  }\r\n\r\n  .row_c {\r\n    display: block;\r\n    min-width: 500px;\r\n  }\r\n\r\n  .row {\r\n    min-width: 500px;\r\n    display: inline-flex;\r\n    margin-bottom: 2%;\r\n  }\r\n\r\n  .contents {\r\n    min-width: 400px;\r\n    float: left;\r\n    margin-right: 6.5%;\r\n  }\r\n\r\n  .contents2 {\r\n    min-width: 400px;\r\n    float: left;\r\n    margin-left: 40%;\r\n  }\r\n\r\n  .contents3 {\r\n    min-width: 400px;\r\n    float: left;\r\n    margin-right: 63%;\r\n  }\r\n  .contents-disable {\r\n    min-width: 400px;\r\n    float: left;\r\n    margin-right: 6.5%;\r\n    pointer-events: none;\r\n  }\r\n\r\n  .contents-button1 {\r\n    min-width: 400px;\r\n    float: center;\r\n    margin-left: 35%;\r\n  }\r\n\r\n  .back {\r\n    background-color: black;\r\n    min-width: 30px;\r\n    float: left;\r\n    margin-left: 6%;\r\n    margin-top: 0.5%;\r\n  }\r\n  .home {\r\n    background-color: black;\r\n    min-width: 30px;\r\n    float: left;\r\n    margin-left: 47%;\r\n    margin-top: 3%;\r\n  }\r\n  .label {\r\n    font-family: ABBVoice-bold;\r\n    font-size: 12px;\r\n    text-align: left;\r\n    margin-bottom: 0.1%;\r\n  }\r\n\r\n  .input-readonly {\r\n    font-family: ABBVoice;\r\n    font-size: small;\r\n    width: 25%;\r\n    height: 27px;\r\n    color: #bdbdbd;\r\n    border: 1px solid #bdbdbd;\r\n    -webkit-transition: 0.5s;\r\n    transition: 0.5s;\r\n    outline: none;\r\n    pointer-events: none;\r\n    border-radius: 5px;\r\n  }\r\n  .dropdown {\r\n    font-family: ABBVoice;\r\n    font-size: small;\r\n    width: 280px;\r\n    -webkit-transition: 0.5s;\r\n    transition: 0.5s;\r\n    outline: none;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n  }\r\n  .dropdown:focus {\r\n    border: 1px solid rgb(51, 102, 255);\r\n  }\r\n  .attach-file {\r\n    font-family: ABBVoice;\r\n    font-size: medium;\r\n    color: gray;\r\n    width: 395px;\r\n    height: 35px;\r\n    border: none;\r\n    -webkit-transition: 0.5s;\r\n    transition: 0.5s;\r\n    outline: none;\r\n  }\r\n  select {\r\n    font-family: ABBVoice;\r\n    font-size: medium;\r\n    color: gray;\r\n    width: 400px;\r\n    height: 40px;\r\n  }\r\n\r\n  textarea {\r\n    font-family: ABBVoice;\r\n    font-size: medium;\r\n    color: var(--text-primary-color);\r\n    min-width: 200px;\r\n    min-height: 30px;\r\n    align-items: left;\r\n    margin-right: 10%;\r\n    background-color: var(--input-field-color);\r\n  }\r\n\r\n  .subheading {\r\n    font-family: ABBVoice;\r\n    font-family: ABBVoice-bold;\r\n    font-size: 16px;\r\n    margin-bottom: 2%;\r\n  }\r\n\r\n  .subheading2 {\r\n    font-family: ABBVoice;\r\n    font-family: ABBVoice-bold;\r\n    font-size: large;\r\n    /* font-style: italic; */\r\n    text-align: left;\r\n    margin-bottom: 1%;\r\n  }\r\n  .button-section {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: end;\r\n    gap: 14px;\r\n    flex-direction: row;\r\n  }\r\n  .button-cancel,\r\n  .button-submit {\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    border: 1px solid transparent;\r\n    transition: background-color 0.3s ease;\r\n    border-radius: 20px;\r\n  }\r\n  .button-attachfile {\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    border-radius: 5px;\r\n    border: 1px solid transparent;\r\n    transition: background-color 0.3s ease;\r\n    border-radius: 20px;\r\n  }\r\n\r\n  .button-submit {\r\n    background: #36f;\r\n    color: white;\r\n    display: inline-flex;\r\n    height: 31px;\r\n    align-items: center;\r\n    gap: 8px;\r\n    flex-shrink: 0;\r\n    text-align: center;\r\n    font-family: ABBvoice;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 100%;\r\n  }\r\n  .file-upload-container {\r\n    display: flex;\r\n    align-items: center; /* Align items vertically in the center */\r\n    gap: 10px; /* Space between the button and the message */\r\n    margin: 16px 0;\r\n  }\r\n  .file-format-message {\r\n    font-size: 12px;\r\n    color: var(--format-message-case-creation);\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .button-attachfile {\r\n    background: #36f;\r\n    color: white;\r\n    display: inline-flex;\r\n    height: 31px;\r\n    align-items: center;\r\n    gap: 8px;\r\n    flex-shrink: 0;\r\n    text-align: center;\r\n    font-family: ABBvoice;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 100%;\r\n  }\r\n\r\n  .button-cancel {\r\n    background: #fff;\r\n    color: #000;\r\n    display: inline-flex;\r\n    height: 31px;\r\n    align-items: center;\r\n    gap: 8px;\r\n    flex-shrink: 0;\r\n    text-align: center;\r\n    font-family: ABBvoice;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 100%;\r\n    border: 1px solid #0051ff;\r\n  }\r\n\r\n  .button-cancel:hover {\r\n    background-color: rgba(0, 0, 0, 0.12);\r\n  }\r\n\r\n  .button-attachfile:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  .privacy-policy-link {\r\n    text-decoration: none;\r\n    color: var(--privacy-policy-link-color);\r\n  }\r\n\r\n  .contents-button2 {\r\n    min-width: 400px;\r\n    float: center;\r\n    margin-right: 10%;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    font-size: 14px;\r\n    margin-left: 75%;\r\n  }\r\n  .loader {\r\n    margin-left: 80%;\r\n    margin-right: 10%;\r\n    min-width: 500px;\r\n    /* align-items: center; */\r\n    display: none;\r\n  }\r\n\r\n  .tick {\r\n    align-items: left;\r\n    margin-top: 6px;\r\n    margin-right: 14px;\r\n    max-width: 20px;\r\n    float: left;\r\n  }\r\n\r\n  .required label {\r\n    font-weight: bold;\r\n  }\r\n  .required label::before {\r\n    color: #e32;\r\n    content: \" *\";\r\n    display: inline;\r\n  }\r\n  .header img {\r\n    float: left;\r\n    width: 50px;\r\n    height: 50px;\r\n  }\r\n  .asterisk {\r\n    color: rgb(217, 83, 79);\r\n    font-size: 18px;\r\n    font-family: ABBVoice-bold;\r\n  }\r\n\r\n  .form-container {\r\n    background-color: var(--container-background-color);\r\n    border-radius: 10px;\r\n    padding: 2px;\r\n    .contact-us-heading {\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      background-color: var(--title-container-background);\r\n      padding: 4px 10px;\r\n      border-top-right-radius: 8px;\r\n      border-top-left-radius: 8px;\r\n    }\r\n    .form-wrapper {\r\n      background-color: var(--title-container-background);\r\n      margin: 12px;\r\n      padding: 16px;\r\n      border-radius: 4px;\r\n\r\n      .field-container {\r\n        display: flex;\r\n        align-items: baseline;\r\n        gap: 10px;\r\n\r\n        .input-wrapper {\r\n          width: 280px;\r\n        }\r\n        .label {\r\n          width: 100px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  .arrow {\r\n    color: black;\r\n    font-size: 18px;\r\n    text-decoration: none;\r\n    margin-bottom: 1%;\r\n    text-align: left;\r\n  }\r\n\r\n  .arrow a {\r\n    text-decoration: none;\r\n    color: inherit;\r\n  }\r\n\r\n  .file-input {\r\n    display: none;\r\n  }\r\n\r\n  .upload-button {\r\n    background-color: rgb(189, 189, 189);\r\n    padding: 5px 20px;\r\n    border-radius: 85px;\r\n    border: none;\r\n    color: white;\r\n    cursor: pointer;\r\n    margin-right: 2%;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .error {\r\n    color: #ad0707;\r\n  }\r\n\r\n  .file_list {\r\n    display: none;\r\n  }\r\n\r\n  .help-tip:before {\r\n    content: \"🛈\";\r\n    font-family: sans-serif;\r\n    font-weight: normal;\r\n    color: #444;\r\n    margin-left: 98.3%;\r\n    font-size: 20px;\r\n  }\r\n\r\n  .help-tip:hover p {\r\n    display: block;\r\n    transform-origin: 100% 0%;\r\n    -webkit-animation: fadeIn 0.3s ease;\r\n    animation: fadeIn 0.3s ease;\r\n  }\r\n\r\n  /* The tooltip */\r\n  .help-tip p {\r\n    display: none;\r\n    font-family: sans-serif;\r\n    text-rendering: optimizeLegibility;\r\n    -webkit-font-smoothing: antialiased;\r\n    text-align: center;\r\n    background-color: #ffffff;\r\n    padding: 15px 16px;\r\n    width: 310px;\r\n    height: 2px;\r\n    position: absolute;\r\n    left: 86.5%;\r\n    top: 24%;\r\n    transform: translate(-50%, 5%);\r\n    border-radius: 3px;\r\n    /* \tborder: 1px solid #E0E0E0; */\r\n    box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.1);\r\n    color: #37393d;\r\n    font-size: 12px;\r\n    line-height: 18px;\r\n    z-index: 99;\r\n  }\r\n  /* The pointer of the tooltip */\r\n  .help-tip p:before {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 0;\r\n    height: 0;\r\n    border: 10px solid transparent;\r\n    border-bottom-color: #ffffff;\r\n    top: 1px;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n\r\n  /* Prevents the tooltip from being hidden */\r\n  .help-tip p:after {\r\n    width: 10px;\r\n    height: 40px;\r\n    content: \"\";\r\n    position: absolute;\r\n    top: -40px;\r\n    left: 0;\r\n  }\r\n\r\n  /* CSS animation */\r\n  @-webkit-keyframes fadeIn {\r\n    0% {\r\n      opacity: 0;\r\n    }\r\n    100% {\r\n      opacity: 100%;\r\n    }\r\n  }\r\n\r\n  @keyframes fadeIn {\r\n    0% {\r\n      opacity: 0;\r\n    }\r\n    100% {\r\n      opacity: 100%;\r\n    }\r\n  }\r\n\r\n  .form-block {\r\n    background-color: var(--title-container-background);\r\n    justify-content: center;\r\n\r\n    .input-wrapper {\r\n      width: 280px;\r\n    }\r\n  }\r\n  .form-block-select {\r\n    .input-wrapper {\r\n      width: 280px;\r\n    }\r\n  }\r\n  .error-message {\r\n    color: \"red\";\r\n  }\r\n  .file-message {\r\n    white-space: nowrap;\r\n    /*margin-left: 20%;*/\r\n  }\r\n\r\n  .selected-file {\r\n    .label {\r\n      font-weight: 600;\r\n      margin-right: 33px;\r\n    }\r\n  }\r\n  .remove-file-button {\r\n    font-size: 10px;\r\n    border: none;\r\n    background-color: #f5f5f5;\r\n    color: #3366ff;\r\n    cursor: pointer;\r\n    padding: 5px 10px;\r\n    border-radius: 4px;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n  }\r\n\r\n  .remove-file-button:hover {\r\n    background-color: #f5f5f5;\r\n    color: #ff000f;\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
